import React from 'react';
import { useRefreshToken } from '../../hooks/useRefreshToken';
import { useSafariAuthPersistence } from '../../hooks/useSafariAuthPersistence';

const SessionManager: React.FC = () => {
  useRefreshToken();
  useSafariAuthPersistence();
  return null;
};

export default SessionManager;
